import { Component, OnDestroy } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { OnInit } from '@angular/core';
import { PsychologistService } from '../psychologist-service/psychologist-service.service';
import { AuthService } from 'src/app/authentication/auth/auth.service';
import { ToastService } from 'src/app/shared/services/toast-service/toast.service';
import {
  BehaviorSubject,
  catchError,
  combineLatest,
  debounceTime,
  Subject,
  Subscription,
  takeUntil,
} from 'rxjs';
import { ToastComponent } from 'src/app/shared/components/toast/toast.component';
import { ModalService } from 'npx-family-happy-common';
import { ProvinceService } from 'src/app/shared/services/province-service/province.service';
import {
  PsychologistState,
  RouterStateManagerService,
} from 'src/app/shared/services/router-state-manager/router-state-manager.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Psychologist } from '../../../shared/models/psychologist.model';
import { CaregiverSelectionRecordSortable } from 'src/app/shared/models/caregiverSelectionRecordSortable.models';
import { PsychologistSummary } from '../../../shared/models/psychologist.model';
import { cellFormatter, emailFormatter } from 'src/app/shared/utils.functions';
import { AlertComponent } from 'src/app/shared/components/modals/alert/alert.component';

// * PSYCHOLOGIST SPECIALTIES
// UMORE
// ANSIA
// STRESS
// AUTOSTIMA
// AFFETTIVITA_E_RELAZIONI
// DIPENDENZE
// LAVORO
// CRESCITA_PERSONALE
// RAGGIUNGIMENTO_OBIETTIVI
// FOBIE,
// ALIMENTAZIONE,
// SESSUALITÀ,
// GENITORIALITÀ,
// LUTTI,
// TRAUMI,
@Component({
  selector: 'app-psychologist-list',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, CommonModule, AlertComponent],
  templateUrl: './psychologist-list.component.html',
  styleUrl: './psychologist-list.component.scss',
})
export class PsychologistListComponent implements OnInit, OnDestroy {
  // variables
  toast!: ToastComponent | null;
  filters: any = {};
  resetFiltersModal = false;
  isAdmin = false;
  private unsubscribe = new Subject<void>();
  psychologists: any[] = [];
  private province = '';
  private psychologistState!: PsychologistState;
  private subscription!: Subscription;
  elementsPerPage = new UntypedFormControl(10);
  filtersRecreated = false;
  original: PsychologistSummary[] = [];
  filtersObserver = new BehaviorSubject<any>(undefined);

  showAlert = false;
  showMore = false;
  showFilters = false;
  selectedRef = '';
  showPageButton = true;

  //MAP FILTERS
  sortableBB: CaregiverSelectionRecordSortable[] = [];
  address!: any;
  addressInput = new UntypedFormControl('');
  resetChildren = false;

  // FORM
  form = new UntypedFormGroup({
    doc_ref: new UntypedFormControl(''),
    name: new UntypedFormControl(''),
    email: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
    age_lower: new UntypedFormControl(null),
    age_upper: new UntypedFormControl(null),
    limit: new UntypedFormControl(10),
    page: new UntypedFormControl(0),
    umore: new UntypedFormControl(false),
    ansia: new UntypedFormControl(false),
    stress: new UntypedFormControl(false),
    autostima: new UntypedFormControl(false),
    affettivita_e_relazioni: new UntypedFormControl(false),
    dipendenze: new UntypedFormControl(false),
    lavoro: new UntypedFormControl(false),
    crescita_personale: new UntypedFormControl(false),
    raggiungimento_obiettivi: new UntypedFormControl(false),
    fobie: new UntypedFormControl(false),
    alimentazione: new UntypedFormControl(false),
    sessualità: new UntypedFormControl(false),
    genitorialità: new UntypedFormControl(false),
    lutti: new UntypedFormControl(false),
    traumi: new UntypedFormControl(false),
  });

  constructor(
    private psychologistService: PsychologistService,
    private provinceService: ProvinceService,
    private stateManager: RouterStateManagerService,
    private modalService: ModalService,
    private authService: AuthService,
    private toastService: ToastService
  ) {
    this.authService
      .getToken()
      .subscribe(
        (token) => (this.isAdmin = this.authService.isUserAdmin(token) ?? false)
      );
    this.toastService
      .getChildComponent()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((component) => (this.toast = component));
  }

  ngOnInit(): void {
    let subscriptions: any = {};
    subscriptions.province = this.provinceService.getProvince().pipe(
      catchError((error) => {
        return error;
      })
    );
    subscriptions.state = this.stateManager.getPsychologistState().pipe(
      catchError((error) => {
        return error;
      })
    );
    combineLatest(subscriptions)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((values: any) => {
        this.province = values.province;
        this.psychologistState = values.state;
        if (!this.psychologistState.filters.province) {
          this.psychologistState.filters.province = '';
        }
        this.psychologistState.filters.page = 0;
        if (Object.keys(this.psychologistState.filters).length > 0) {
          if (this.province !== this.psychologistState.filters.province) {
            this.filters = this.recreateFilterObject(
              this.psychologistState.filters,
              false
            );
          } else {
            this.filters = this.recreateFilterObject(
              this.psychologistState.filters,
              true
            );
          }
          this.psychologistState.filters.province;
          this.filtersObserver.next(this.filters);
          this.form.patchValue(
            {
              doc_ref: this.psychologistState.filters.doc_ref ?? '',
              name: this.psychologistState.filters.info?.name ?? '',
              email: this.psychologistState.filters.info?.email ?? '',
              phone: this.psychologistState.filters.info?.phone ?? '',
              age_lower: this.psychologistState.filters.age_lower ?? null,
              age_upper: this.psychologistState.filters.age_upper ?? null,
              page: 0,
            },
            { emitEvent: true }
          );
        }
        if (!this.subscription) {
          if (this.psychologistState.filters.province === '') {
            this.psychologistState.filters.province = null;
          }
          this.subscription = this.psychologistService
            .getPsychologist(
              this.psychologistState.filters,
              this.elementsPerPage.value
            )
            .subscribe((data: any) => {
              if (!this.filtersRecreated) {
                this.populatePsychologist(data);
              } else {
                this.filtersRecreated = false;
              }
            });
          this.form.valueChanges
            .pipe(debounceTime(300), takeUntil(this.unsubscribe))
            .subscribe((value) => {
              if (value.page > (this.psychologistState.filters.page ?? 0)) {
                try {
                  this.processFilters();
                  this.askMorePsychologists();
                } catch (err) {
                  this.modalService.showErrorMessage(
                    'Non è stato possibile caricare i nuovi dati aggiornati.'
                  );
                }
              } else {
                this.psychologists = [];
                this.processFilters();
                this.page?.setValue(0, { emitEvent: false });
                try {
                  this.askMorePsychologists();
                } catch (err) {
                  this.modalService.showErrorMessage(
                    'Non è stato possibile caricare i nuovi dati aggiornati.'
                  );
                }
              }
            });
          this.elementsPerPage.valueChanges
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((value) => {
              this.psychologists = [];
              this.psychologistService
                .getPsychologist(this.psychologistState.filters, value)
                .subscribe();
            });
        }
      });

    this.form.valueChanges
      .pipe(debounceTime(300), takeUntil(this.unsubscribe))
      .subscribe((value) => {
        this.filters = {
          doc_ref: value.doc_ref ?? null,
          name: value.name ?? null,
          email: value.email ?? null,
          phone: value.phone ?? null,
          age_lower: value.age_lower ?? null,
          age_upper: value.age_upper ?? null,
          specialties: this.populateSpecialties() ?? null,
        };
      });
  }

  populateSpecialties() {
    let specialties: string[] = [];
    if (this.form.get('umore')?.value) {
      specialties.push('umore'.toUpperCase());
    }
    if (this.form.get('ansia')?.value) {
      specialties.push('ansia'.toUpperCase());
    }
    if (this.form.get('stress')?.value) {
      specialties.push('stress'.toUpperCase());
    }
    if (this.form.get('autostima')?.value) {
      specialties.push('autostima'.toUpperCase());
    }
    if (this.form.get('affettivita_e_relazioni')?.value) {
      specialties.push('affettivita_e_relazioni'.toUpperCase());
    }
    if (this.form.get('dipendenze')?.value) {
      specialties.push('dipendenze'.toUpperCase());
    }
    if (this.form.get('lavoro')?.value) {
      specialties.push('lavoro'.toUpperCase());
    }
    if (this.form.get('crescita_personale')?.value) {
      specialties.push('crescita_personale'.toUpperCase());
    }
    if (this.form.get('raggiungimento_obiettivi')?.value) {
      specialties.push('raggiungimento_obiettivi'.toUpperCase());
    }
    if (this.form.get('fobie')?.value) {
      specialties.push('fobie'.toUpperCase());
    }
    if (this.form.get('alimentazione')?.value) {
      specialties.push('alimentazione'.toUpperCase());
    }
    if (this.form.get('sessualità')?.value) {
      specialties.push('sessualità'.toUpperCase());
    }
    if (this.form.get('genitorialità')?.value) {
      specialties.push('genitorialità'.toUpperCase());
    }
    if (this.form.get('lutti')?.value) {
      specialties.push('lutti'.toUpperCase());
    }
    if (this.form.get('traumi')?.value) {
      specialties.push('traumi'.toUpperCase());
    }
    return specialties;
  }

  get specialties() {
    return this.form.get('specialties');
  }

  get page() {
    return this.form.get('page');
  }
  get doc_ref() {
    return this.form.get('doc_ref');
  }
  get name() {
    return this.form.get('name');
  }
  get email() {
    return this.form.get('email');
  }
  get phone() {
    return this.form.get('phone');
  }
  get age_lower() {
    return this.form.get('age_lower');
  }
  get age_upper() {
    return this.form.get('age_upper');
  }

  get limit() {
    return this.form.get('limit');
  }

  rowClick(Psychologist: Psychologist | undefined) {
    if (!Psychologist) {
      this.psychologistState.id = 'new';
    } else {
      this.psychologistState.id = Psychologist.docRef;
    }
    this.psychologistState.route =
      'psychologist-detail/' + this.psychologistState.id;
    this.psychologistState.step = 0;
    this.psychologistState.psychologist = undefined;
    this.ngOnDestroy();
    this.stateManager.setPsychologistState(this.psychologistState);
  }

  copyToClipboard(event: any) {
    navigator.clipboard.writeText(event);
    this.toastService.setAction(
      'Dati copiati con successo! Ora puoi incollarli dove vuoi.',
      true
    );
  }

  deletePsychologist(doc_ref: string) {
    this.selectedRef = doc_ref;
    this.showAlert = true;
  }

  // delete alert confirmation
  onAlertConfimation(event: boolean) {
    if (event) {
      const index = this.psychologists.findIndex(
        (item) => item.doc_ref === this.selectedRef
      );
      this.psychologists.splice(index, 1);
      this.original.splice(index, 1);
      this.psychologistService
        .deletePsychologist(this.selectedRef)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((res: any) => {
          this.modalService.outcomeMessage.next(
            'Psicologo eliminata con successo.'
          );
          this.modalService.outcomeType.next('Success');
          this.modalService.showOutcome.next(true);
        });
    }
    this.selectedRef = '';
    this.showAlert = false;
  }

  resetFilters() {
    this.psychologists = [];
    this.resetFiltersModal = true;
    this.resetChildren = true;
    this.form.reset(
      {
        doc_ref: '',
        name: '',
        email: '',
        phone: '',
        specialties: '',
      },
      { emitEvent: false }
    );
    // Reset psychologist filter modal filters
    this.filters = undefined;
    this.filtersObserver.next(this.filters);
    this.askMorePsychologists(true);
  }

  processFilters(reset = false) {
    this.showFilters = false;
    let filters: any = {};
    if (reset) {
      filters = { page: 0 };
    } else {
      filters.page = this.page?.value;
      if (this.doc_ref?.value !== '') {
        filters.doc_ref = this.doc_ref?.value;
      }
      // 1. CHIAMATA E ASSEGNAZIONE CORRETTA
      const selectedSpecialties = this.populateSpecialties();

      // 2. CONTROLLO E INSERIMENTO NEL FILTRO
      if (selectedSpecialties.length > 0) {
        filters.specialties = selectedSpecialties;
      }
      if (this.name?.value !== '') {
        if (filters) {
          filters.name = this.name?.value;
        }
      }
      if (this.email?.value !== '') {
        if (filters) {
          let formattedMail = emailFormatter(this.email?.value);
          filters.email = formattedMail;
        }
      }
      if (this.phone?.value !== '') {
        if (filters) {
          let formattedPhone = cellFormatter(this.phone?.value);
          filters.phone = formattedPhone;
        }
      }
      if (this.age_lower?.value || this.age_upper?.value) {
        filters.age_lower = this.age_lower?.value;
        filters.age_upper = this.age_upper?.value;
      }
      filters.limit = this.limit?.value;
      if (this.filters) {
        if (this.filters.lang) {
          if (this.filters.lang.english) {
            filters.lang.english = true;
          }
          if (this.filters.lang.italian) {
            filters.lang.italian = true;
          }
          if (this.filters.lang.spanish) {
            filters.lang.spanish = true;
          }
          if (this.filters.lang.englishAdvanced) {
            filters.lang.englishAdvanced = true;
          }
          if (this.filters.lang.italianAdvanced) {
            filters.lang.italianAdvanced = true;
          }
          if (this.filters.lang.spanishAdvanced) {
            filters.lang.spanishAdvanced = true;
          }
        }
        if (this.filters.exp) {
          if (this.filters.exp.cluster1) {
            filters.exp.cluster1 = true;
          }
          if (this.filters.exp.cluster2) {
            filters.exp.cluster2 = true;
          }
        }
      }
      this.populateSpecialties();
      if (this.specialties?.value && this.specialties?.value.length > 0) {
        filters.specialties = this.specialties?.value;
      }
    }
    if (this.province !== '') {
      if (!filters || Object.keys(filters).length === 0) {
        filters = { province: this.province };
      } else {
        filters.province = this.province;
      }
    }
    return filters;
  }

  askMorePsychologists(resetFilters = false) {
    const filters = this.processFilters(resetFilters);
    try {
      this.psychologistState.filters = filters;
      this.psychologistService
        .getPsychologist(filters, this.elementsPerPage.value)
        .subscribe((psychologists) => {
          if (psychologists.length < this.elementsPerPage.value) {
            this.showPageButton = false;
          } else {
            this.showPageButton = true;
          }
        });
    } catch (err) {
      this.modalService.showErrorMessage(
        'Non è stato possibile caricare i nuovi dati aggiornati.'
      );
    }
  }

  generateCaregiverListSortable(bb: Psychologist[]) {
    this.sortableBB = [];
    bb.forEach((psychologist) => {
      let bbSortable = {
        fittingIndex: 0,
        record: {
          id: 0,
          requestID: 0,
          babysitter: null,
          petsitter: null,
          nurse: null,
          colf: null,
          nutritionist: null,
          psychologist: psychologist,
          coach: null,
          suitable: false,
          suitableDate: null,
          selected: false,
          selectedDate: null,
          chosen: false,
          chosenDate: null,
          discarded: false,
          discardedDate: null,
          discardedReason: '',
          distance: 0,
          favorite: false,
          cvSent: false,
          cvSentDate: null,
          contactSent: false,
          contactSentDate: null,
        },
      };
      this.sortableBB.push(bbSortable);
    });
  }

  private populatePsychologist(array: Psychologist[]) {
    if (array.length > 0) {
      this.generateCaregiverListSortable(array);
      this.original = array.map((item) => {
        return {
          name: item.info ? item.info.name : '-',
          surname: item.info ? item.info.surname : '-',
          email: item.info ? item.info.email : '-',
          phone: item.info ? item.info.phone : '-',
          docRef: item.docRef,
          cv: item.info.resumeHidden ?? '-',
          video: item.info.video,
          creationDate: new Date(),
          subscription: item.info.subscription,
          manualSubscription: item.info.manualSubscription,
          certificate: item.certificate,
        };
      });
    } else {
      this.generateCaregiverListSortable(array);
      this.original = [];
    }
    this.psychologists.push(...this.original);
  }

  recreateFilterObject(filters: any, fromRequest: boolean) {
    if (filters) {
      if (fromRequest) {
        this.filtersRecreated = true;
      }
      return {
        page: filters.page ?? 0,
        minAge: this.age_lower?.value ?? null,
        maxAge: this.age_upper?.value ?? null,
        lang: {
          english: filters.lang ? filters.lang.english === true : false,
          englishAdvanced: filters.lang
            ? filters.lang.englishAdvanced === true
            : false,
          italian: filters.lang ? filters.lang.italian === true : false,
          italianAdvanced: filters.lang
            ? filters.lang.italianAdvanced === true
            : false,
          spanish: filters.lang ? filters.lang.spanish === true : false,
          spanishAdvanced: filters.lang
            ? filters.lang.spanishAdvanced === true
            : false,
        },
      };
    }
    return undefined;
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
